import { useQuery } from '@tanstack/react-query';
import { CancellationReasonsService } from '../services';
import { IGetCancellationReasonsPayload } from '../types';

export const useGetCancellationReasons = (payload?: IGetCancellationReasonsPayload) => {
  const { data, isFetching, isLoading, isError, error } = useQuery({
    initialData: {
      data: [],
    },
    queryKey: ['GET_CANCELLATION_REASONS', { payload }],
    queryFn: async () => CancellationReasonsService.getCancellationReasons(payload),
    retry: false,
  });

  return {
    ...data,
    isInitialLoading: isLoading,
    isLoading: isLoading || isFetching,
    isError,
    error,
  };
};
